<!--活动表单-->
<template>
    <v-card :color="theme.elementBgColor">
        <v-card-title>
            {{ form.id ? form.no + "--------" + "id：" + form.id : "添加IC卡" }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mt-3">
            <el-form :model="form" label-width="8vw" class="pb-6" label-position="top">
                <el-form-item label="16位IC卡编号" :rules="[{ required: true }]">
                    <el-input v-model="form.no" autocomplete="off" clearable style="width: 100%">
                        <i class="el-icon-edit" slot="prepend"></i>
                    </el-input>
                </el-form-item>
				<el-form-item label="平台" v-if="role === 0" :rules="[{ required: true }]">
					<select-platform
						@choose="choosePlatformId"
					    :selectPlatform="form.platform_id"
					    :width="'100%'"
					/>
				</el-form-item>
				<el-form-item label="适用站点数组,为空则为所有站点可用" :rules="[{ required: true }]">
					<select-site
					    :width="'100%'"
					    :selectSite="form.stations"
					    @choose="chooseSite"
					    :multiple="true"
					    :isAll="false"
					/>
				</el-form-item>
            </el-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="dialog-footer d-flex justify-space-around pb-5">
            <v-btn width="30%" @click="cancel()" class="float-left">取消</v-btn>
            <v-btn width="30%" color="primary" @click="determine()" class="float-right">
                确定
            </v-btn>
        </v-card-actions>
    </v-card>
</template>
<script>
import { mapState } from "vuex";
import util from "@/util";
import Public from "@/public"
import store from "@/store";
import SelectSite from "@/components/SelectSite";
import SelectPlatform from "@/components/SelectPlatform";
export default {
    name: "ICForm",
	components: {
		SelectSite,
		SelectPlatform
	},
    data() {
        return {
			isSite: true,
            form: {
                id: null,
                no: null,
				platform_id: null, //平台
				stations: null   //适用站点数组 null则为所有站点可用
            },
        };
    },
    props: {
        isAdd: Boolean,
		isEdit: Boolean,
		icData: Object
    },
	mounted() {
	    Object.keys(this.form).forEach(key => {
	        this.form[key] = this.icData[key];
	    });
	},
	watch: {
	    form() {
	        this.isSite = false;
	        this.$nextTick(() => {
	            this.isSite = true;
	        });
	    },
	},
    created() {
		if(this.role === 1) {
			this.form["platform_id"] = this.platform_id;
		}
	},
    computed: {
        ...mapState(["theme", "couponInfos","role","platform_id"]),
    },
    methods: {
        /*确定*/
        determine() {
            if (!this.form.no) {
                util.ShowTip("必填项不能为空", 3);
                return;
            }
			if(this.form.no.length != 16) {
				util.ShowTip("IC卡编号必须为16位数", 3);
				return;
			}
            let params = {
                postData: {
                    no:  Public.removeSpace(this.form.no),
					platform_id: this.form.platform_id,
					stations: this.form.stations
                },
                callbackOk: () => {
                    this.$emit("refresh");
                    this.cancel();
                },
            };
            if (this.isAdd) {
                store.dispatch("addICCard", params);
            } else if(this.isEdit){
                // store.dispatch("updateConnact", params);
            }
        },
        /*选择平台*/
		choosePlatformId(e) {
			this.form.platform_id = e
		},
		// 选择站点
		chooseSite(site) {
			if(site.siteIds.length == 0) {
				this.form.stations = null;
			}else {
				this.form.stations = site.siteIds;
			}
		},
		/*取消*/
        cancel() {
            Object.keys(this.form).forEach(key => {
                this.form[key] = null;
            });
            this.$emit("cancel");
        },
        JsonData(data) {
            return JSON.parse(JSON.stringify(data));
        },
    },
};
</script>
